// 心理日记
const dailylist = resolve =>
  require(['../../../views/xinlidaily/dailyList'], resolve)

export default [
  // 心理日记
  {
    path: '/dailylist',
    component: dailylist
  }
]



// WEBPACK FOOTER //
// ./src/router/page/xinlidaily/dailylist.js